import type { StatusType } from "@/constants/status-type"
import { dataByStatusType } from "@/constants/status-type"
import { cn } from "@/lib/utils"

export { StatusType } from "@/constants/status-type"

export function StatusIcon({ status }: { status: StatusType }) {
  const { icon: Icon, bgClass, textClass } = dataByStatusType[status]

  return (
    <div
      className={cn(
        "border-border flex size-10 shrink-0 items-center justify-center border-2",
        bgClass
      )}
    >
      <Icon className={cn("size-6", textClass)} />
    </div>
  )
}
